import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { CustomerUser } from '@app/core/models/customer.models';
import { User } from '@app/core/models/user.models';
import { getUserInitials } from '@app/core/utilities/user.utilities';

@Component({
  selector: 'adspt-user-avatar',
  templateUrl: 'user-avatar.component.html',
  styleUrls: ['user-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent implements OnChanges {
  initials?: string;

  @Input()
  user?: User | CustomerUser;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.user) {
      this.initials = getUserInitials(this.user);
    }
  }
}
